export type LabeledValueProps = {
  title: React.ReactNode;
  containerClassName?: string;
  children: React.ReactNode;
};
export default function LabeledValue({
  title,
  children,
  containerClassName,
}: LabeledValueProps) {
  return (
    <div className="labeled-value">
      <div
        className={`title light-text ${containerClassName ? containerClassName : ''}`}
      >
        {title}
      </div>
      <div className="value">{children}</div>
    </div>
  );
}
